import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

export async function generateDocument(applicationId: string): Promise<Blob> {
  return makeRequest<Blob>({
    httpMethod: 'POST',
    responseType: 'blob',
    type: 'json',
    url: `${config.apiHost}/merchant-portal/api/v1/documents/public/generate`,
    timeout: 60 * 2 * 1000,
    withCredentials: true,
    payload: { type: 'LOAN_NOTIFICATION', applicationId },
  });
}
